import { StatusesHeader } from '@app/modules/logger/screens/status/components/header/StatusesHeader';
import { useAllStationsStatuses } from '@app/modules/logger/screens/status/hooks/useStatusFilters';
import { useStatusSettingsStore } from '@app/modules/logger/screens/status/stores/status-settings.store';
import { ViewLoader } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { Page } from '../../../../components/page/Page';
import { StatusLayout } from './components/status/layout/StatusLayout';

export function LoggerStatusPage() {
  const { $t } = useIntl();
  const { filteredStatuses, statuses, isLoading } = useAllStationsStatuses();
  const view = useStatusSettingsStore((state) => state.view);

  const title = $t({
    id: 'logger.statusScreen.title',
    defaultMessage: 'Panorama',
  });

  return (
    <Page htmlTitle={title}>
      <StatusesHeader statuses={statuses} isLoading={isLoading} />
      <Page.Content>
        {isLoading ? (
          <ViewLoader
            loaderData={$t({
              id: 'logger.statusScreen.loading',
              defaultMessage: 'Cargando emisoras',
            })}
          />
        ) : (
          <StatusLayout statuses={filteredStatuses} variant={view} />
        )}
      </Page.Content>
    </Page>
  );
}
